import React from 'react';
import { StackedBarChartType } from '../../enum';

const CustomLegend = ({ subjectKeys, getColor, chartType = StackedBarChartType.RESULTS }) => {
    return (
        <>
            {chartType === StackedBarChartType.RESULTS && (
                <div className="legend-container">
                    <div className="custom-legend">
                        {subjectKeys.map((subject) => (
                            <div key={subject} className="legend-item">
                                <div
                                    className="legend-color"
                                    style={{ backgroundColor: getColor(subject) }}
                                />
                                <span className="legend-label">{subject}</span>
                            </div>
                        ))}
                        <div className="legend-item">
                            <div
                                className="legend-color"
                                style={{ backgroundColor: '#000000' }}
                            />
                            <span className="legend-label">Overall</span>
                        </div>
                    </div>
                </div>
            )}

            {chartType === StackedBarChartType.SUBJECTRESULTS && (
                <div className="legend-container">
                    <div className="custom-legend">
                        {subjectKeys.map((item) => (
                            <div key={item.grade} className="legend-item">
                                <div
                                    className="legend-color"
                                    style={{ backgroundColor: item.color }}
                                />
                                <span className="legend-label">{item.grade}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default CustomLegend;
